import React from "react";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import TurnrInput from "~/components/input/TurnrInput.jsx";
import { getCookiePolicyOptions } from "~/cores/appCore";
import { PRIVACY_POLICY_DEFAULT_URL } from "rylak-common/src/constants";

export default function LoginSettings(props) {
    const { iFrameData, appProps } = props;

    const cookiePolicySettings = getCookiePolicyOptions(appProps);
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip="The label at the login screen for the order input field"
                    label="Order ID Label"
                    fullWidth={true}
                    {...props.orderIdText}
                    onChange={props.setOrderIdText}
                    options={iFrameData?.orderIdLabels || []}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    tooltip="Simply the prefix for the order input field on the login screen"
                    valueKey="orderIdPrefix"
                    fullWidth={true}
                    {...props.orderIdPrefix}
                    onChange={props.setOrderIdPrefix}
                    selectNoneComponent={"None"}
                    options={["#", "@"]}
                    label="Order ID Prefix"
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    label="Terms & Conditions Url"
                    tooltip={<div>If you want to show a terms and conditions url at login</div>}
                    fullWidth={true}
                    {...props.termsAndConditionsUrl}
                    onChange={props.setTermsAndConditionsUrl}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    label="Privacy Policy Url"
                    tooltip={
                        <div>
                            If you decide to use your own privacy policy url instead of our default one
                            <br />
                            <br />
                            <b>{PRIVACY_POLICY_DEFAULT_URL}</b>
                            <br />
                            <br />
                            Then it might be a good idea to link to our in your privacy policy url
                        </div>
                    }
                    fullWidth={true}
                    {...props.privacyPolicyUrl}
                    onChange={props.setPrivacyPolicyUrl}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    label="Return Policy Url"
                    tooltip="The url to your return policy page. We link to this page in the app so your customers are informed"
                    fullWidth={true}
                    {...props.returnPolicyUrl}
                    onChange={props.setReturnPolicyUrl}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Cookies Policy"
                    tooltip="You might want to disable the cookie popup for UX-reasons if you are using our Return Portal in Iframe mode"
                    fullWidth={true}
                    {...props.cookiesPolicy}
                    onChange={props.setCookiesPolicy}
                    options={cookiePolicySettings}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
